import { optionify } from 'lib/helpers/utility';
import { useStates } from 'lib/hooks/queries/states/useStates';

import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';
import SectionList from 'components/practice/UserPreferences/components/SectionList';

const AddressSection = ({ formik }) => {
  const { data: statesData } = useStates();
  const stateOptions = optionify(statesData?.states);

  const areAllFieldsEmpty =
    !formik.values.address?.trim() &&
    !formik.values.city?.trim() &&
    !formik.values.zip?.trim() &&
    !formik.values.state;

  const shouldBeOptional = areAllFieldsEmpty;

  return (
    <div>
      <SectionList
        title="Address"
        description="Enter the address associated with the staff member to ensure accurate billing and verification.">
        {!formik.values.address_is_same_as_practice && (
          <div className="grid grid-cols-2 gap-3">
            <Input
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              label="Address 1"
              placeholder="Enter address"
              error={formik.errors.address}
              isOptional={shouldBeOptional}
            />
            <Input
              name="address_2"
              value={formik.values.address_2}
              onChange={formik.handleChange}
              label="Address 2"
              isOptional
              placeholder="Enter address"
            />
            <Input
              name="city"
              value={formik.values.city}
              onChange={formik.handleChange}
              label="City/location"
              placeholder="Enter city"
              error={formik.errors.city}
              isOptional={shouldBeOptional}
            />
            <Input
              name="zip"
              value={formik.values.zip}
              onChange={formik.handleChange}
              label="Zip code"
              placeholder="Enter zip"
              error={formik.errors.zip}
              isOptional={shouldBeOptional}
            />
            <Select
              name="state"
              menuPortalTarget={document.body}
              value={
                formik.values.state && {
                  label: stateOptions.find((s) => s.value === formik.values.state)?.label
                }
              }
              onChange={(option) => formik.setFieldValue('state', option?.value)}
              label="State"
              inputId="select-state"
              options={stateOptions}
              placeholder="Select state"
              error={formik.errors.state}
              isOptional={shouldBeOptional}
            />
          </div>
        )}
      </SectionList>
    </div>
  );
};

export default AddressSection;
